
import {
  invokeShopifyQuery,
  GIFT_ADDS,
  SUBS_TAGS, STANDARD_SIZE, DELUXE_SIZE, GRAND_SIZE, LUXE_COLLECTION
} from "@/utils/shopify";
import ProductMapMixin from "~/mixin/product-map-mixin";
import ShopifyProduct from "~/types/shopify/ShopifyProduct";
import DeliveryWeekMixin from "~/mixin/delivery-week-mixin";
export default {
  name: "cal-subs-size",
  props: {
    subsCMSData: {
      type: Object,
      required: true
    },
    isOngoing: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    "isStandardActive"(){
      this.validateState()
    },
    "isDeluxeActive"(){
      this.validateState()
    },
    "isGrandActive"(){
      this.validateState()
    }
  },
  data() {
    return {
      subsAddons: [] as any[],
      showModal: false,
      showGreets: false,
      mainTitle: "",
      standardType: {
        id: STANDARD_SIZE
      },
      deluxeType: {
        id: DELUXE_SIZE
      },
      grandType: {
        id: GRAND_SIZE
      },
      currSize: this.$store.state.cartItem.selectedSubscription.variantType,
      isStandardActive: this.$store.state.cartItem.selectedSubscription.variantType == STANDARD_SIZE,
      isDeluxeActive: this.$store.state.cartItem.selectedSubscription.variantType == DELUXE_SIZE,
      isGrandActive: this.$store.state.cartItem.selectedSubscription.variantType == GRAND_SIZE
    };

  },
  computed: {
    product(): any {
      return this.$store.state.cartItem.subscriptionProd;
    },
    selectedSize(): any {
      return [{addon: {id: this.currSize}}]
    },
    isLuxe(): any {
      return this.$store.state.cartItem.selectedSubscription.collectionType == LUXE_COLLECTION;
    }

  },
  mixins: [ProductMapMixin, DeliveryWeekMixin],
  methods: {
    toggleEvent(event: any) {
      if (event.addon.id == STANDARD_SIZE) {
        this.isStandardActive = !this.isStandardActive;
        this.isDeluxeActive = false;
        this.isGrandActive = false;
      } else if (event.addon.id == DELUXE_SIZE) {
        this.isDeluxeActive = !this.isDeluxeActive;
        this.isStandardActive = false;
        this.isGrandActive = false;
      }else{
        this.isGrandActive = !this.isGrandActive;
        this.isStandardActive = false;
        this.isDeluxeActive = false;
      }
      if(this.isStandardActive || this.isDeluxeActive || this.isGrandActive ){
        this.$store.dispatch("cartItem/SUB_VARIANT_SET", event.addon.id);
        this.$nuxt.$emit("updatedSubSize");
      }
      else{
        this.$store.dispatch("cartItem/SUB_VARIANT_RESET");
      }
    },
    isObjectNotEmpty(obj: any) {
      return Object.keys(obj).length > 0;
    },
    validateState(){
      if((this.isStandardActive && !this.isLuxe) || this.isDeluxeActive || this.isGrandActive){
        this.$nuxt.$emit("subsSizeDisabled", false);
      }else{
        this.$nuxt.$emit("subsSizeDisabled", true);
      }
    }
  },
  created() {
    this.validateState();
    this.$nuxt.$on("subVariantReset", () => {
      this.isStandardActive = false
      this.isDeluxeActive = false
      this.isGrandActive = false
      this.$store.dispatch("cartItem/SUB_VARIANT_RESET");
    });

    this.$nuxt.$on("scrollToSubsSize", () => {
      const SubsSizeEl = document.getElementById("subs-size");
      if (SubsSizeEl) {
        SubsSizeEl.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    });
  },
};
